<cf-notification-container [heading]="heading" [description]="description || ''">
  <div class="card bg-raven-5 border-0">
    <div class="text-center">
      <ng-container *ngIf="withPicture">
        <cf-avatar
          *ngIf="picture"
          [src]="$any(picture.image)"
          [rounded]="$any(picture.rounded)"
          size="xl"
          class="mb-2"
        ></cf-avatar>
      </ng-container>

      <h3 class="mb-2">{{ title }}</h3>

      <cf-text>
        <cf-text-truncate [text]="booking.description ?? ''"></cf-text-truncate>
      </cf-text>
    </div>

    <cf-booking-information
      [day]="selectedSlot.date"
      [time]="selectedTime"
      [timezone]="timezone"
      [duration]="selectedDuration"
      [participantsTmp]="participantsTmp"
      [location]="location!"
      class="mt-3"
    >
      <ng-template #participantsTmp>
        <cf-participant-list
          *ngIf="participantsAmount"
          [hideParticipants]="true"
          [participantsAmount]="participantsAmount"
        ></cf-participant-list>
      </ng-template>
    </cf-booking-information>
  </div>
  @if (hasRedirect) {
    <div class="d-flex flex-column mt-4">
      <cf-text size="sm" weight="600">
        <svg cfIcon="update" class="tw:text-blue-50"></svg>
        {{ "booking.redirecting_to_the_final_page_in" | translate: { seconds: (redirectTimer$ | async)!.toString() } }}
      </cf-text>

      <cf-text weight="500" size="sm" class="mt-2">
        {{ "booking.if_the_page_hasnt_opened_please_click_here" | translate }}
      </cf-text>
      <a cf-link size="sm" weight="500" [href]="redirectUrl" target="_self" rel="noreferrer noopener" maxLineClamp="1">
        {{ redirectUrl }}
      </a>
    </div>
  }
  <div class="mt-4" [class.pointer-none]="isPreview">
    @if ((isPreview || !account.id) && showCalfrenzyLogo) {
      <h4 class="mb-0">{{ "booking.try_calfrenzy_free_forever_plan" | translate }}</h4>
      <cf-text size="lg"> {{ "booking.no_credit_card_required" | translate }} </cf-text>

      <div class="d-flex align-items-center auth-group mt-3 gap-2">
        <cf-google-auth class="w-100" color="secondary" [redirectToSignUp]="true"></cf-google-auth>
        <cf-microsoft-auth class="w-100" color="secondary" [redirectToSignUp]="true">
          {{ "auth.sign_up_microsoft" | translate }}
        </cf-microsoft-auth>
      </div>

      <div class="form-separator my-3">
        <cf-text color="grey-40" size="xl" touchSize="md">{{ "booking.or" | translate }}</cf-text>
      </div>

      <cf-button class="text-nowrap" className="px-3" (click)="signUp()">
        {{ "bp.sign-up-with-email" | translate }}
      </cf-button>
    } @else {
      @if (!isPreview) {
        <cf-text *ngIf="eventAddedToCalendar">
          {{ "booking.this_event_is_successfully_added_to_your_calendar_generic" | translate }}
        </cf-text>
      }
    }
  </div>
  @if (scheduleAnotherEventButton) {
    <div class="mt-4 text-center" (click)="reload()">
      <a cf-link size="sm"> {{ "booking.schedule_another_event" | translate }} </a>
    </div>
  }
</cf-notification-container>
